import firebase from "firebase";

var config = {
    apiKey: "AIzaSyALZzdZcvQUE__3g_QAkDHo9-AoFpSBcxw",
    authDomain: "react-todo-686fa.firebaseapp.com",
    databaseURL: "https://react-todo-686fa.firebaseio.com",
    projectId: "react-todo-686fa",
    storageBucket: "react-todo-686fa.appspot.com",
    messagingSenderId: "62621174480"
};

var firedb = firebase.initializeApp(config);
export default firedb


// WEBPACK FOOTER //
// ./src/fire.js